let env
if (location.hostname.indexOf('localhost') >= 0 || location.hostname.indexOf('10.0') >= 0 || location.hostname.indexOf('172.19') >= 0) {
  env = {
    countlyAppKey: 'cb95b4e9125098b99a7df2fbda4554eda982918b',
    countlyServer: '//10.252.11.231:8080',
    apiUrl: 'https://upms.startimes.me',
    facebookAppId: 2487354764876530
  }
} else if (location.hostname.indexOf('dev') >= 0) {
  env = {
    countlyAppKey: 'cb95b4e9125098b99a7df2fbda4554eda982918b',
    countlyServer: '//10.252.11.231:8080',
    apiUrl: '//upms.startimes.me',
    facebookAppId: 2487354764876530
  }
} else if (location.hostname.indexOf('test') >= 0) {
  env = {
    countlyAppKey: 'cb95b4e9125098b99a7df2fbda4554eda982918b',
    countlyServer: '//10.252.11.231:8080',
    apiUrl: 'https://upms.startimes.me',
    facebookAppId: 2487354764876530
  }
} else {
  env = {
    countlyAppKey: 'cd58cfb3e81658905d802cbe44b04683effbc7ed',
    countlyServer: '//event.startimestv.com',
    apiUrl: '//upms.startimestv.com',
    facebookAppId: 159785064477978
  }
}
export default env
